module.exports = __webpack_public_path__ + "static/media/truckDeliver2.ffbe475f.png";